<template>
  <div class="pb-3">
    <div class="d-flex py-4">
      <div
        class="bar position-relative"
        :class="'bar-' + data.o"
      />
      <div
        class="bar position-relative"
        :class="'bar-' + data.c"
      />
      <div
        class="bar position-relative"
        :class="'bar-' + data.e"
      />
      <div
        class="bar position-relative"
        :class="'bar-' + data.a"
      />
      <div
        class="bar position-relative"
        :class="'bar-' + data.n"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
  .bar {
    border-top: 1px black solid;
    flex: 1;
    margin: 0 2px;
  }

  .bar::after {
    position: absolute;
    bottom: -40px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .bar:nth-child(1)::after {
    content: "O";
  }

  .bar:nth-child(2)::after {
    content: "C";
  }

  .bar:nth-child(3)::after {
    content: "E";
  }

  .bar:nth-child(4)::after {
    content: "A";
  }

  .bar:nth-child(5)::after {
    content: "N";
  }

  .bar:before {
    content: " ";
    width: 100%;
    position: absolute;
  }

  .bar-2:before {
    background: #2dc3e4;
    height: 16px;
    bottom: calc(50% + 1px);
  }

  .bar-1:before {
    background: #2aea77;
    height: 8px;
    bottom: calc(50% + 1px);
  }

  .bar-0:before {

  }

  .bar--1:before {
    background: #ffab14;
    height: 8px;
    top: 50%;
  }

  .bar--2:before {
    background: #ff7516;
    height: 16px;
    top: 50%;
  }
</style>
